// Horizon scrolls a wrapper div (html/body stay overflow:hidden ≥990px), so
// window.scrollY never moves and third-party lazy-loaders keyed to window
// scroll — Judge.me review photos among them — never fire. This element
// (1) re-dispatches wrapper scroll on window for position-agnostic loaders and
// (2) promotes Judge.me's data-src images itself once they near the viewport,
// which covers loaders that read window.scrollY directly.
class LettoriaScrollBridge extends HTMLElement {
  connectedCallback() {
    const wrapper = document.querySelector('div.page-wrapper');
    if (wrapper) {
      this.forward = () => window.dispatchEvent(new Event('scroll'));
      wrapper.addEventListener('scroll', this.forward, { passive: true });
    }

    this.io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const img = entry.target;
          const src = img.getAttribute('data-src');
          if (src && !img.src) {
            img.addEventListener(
              'load',
              () => img.closest('.jdgm-rev__pic-link, .jdgm--loading')?.classList.remove('jdgm--loading'),
              { once: true }
            );
            img.src = src;
          }
          this.io.unobserve(img);
        }
      },
      { root: null, rootMargin: '400px' }
    );

    this.scan = () => {
      document.querySelectorAll('img[data-src].jdgm-rev__pic-img:not([src])').forEach((img) => this.io.observe(img));
    };
    this.scan();

    // the widget hydrates and paginates asynchronously — rescan on DOM changes
    const jdgmRoot = document.querySelector('.jdgm-widget');
    if (jdgmRoot) {
      this.mo = new MutationObserver(() => this.scan());
      this.mo.observe(jdgmRoot, { childList: true, subtree: true });
    }
    setTimeout(this.scan, 1500);
  }

  disconnectedCallback() {
    const wrapper = document.querySelector('div.page-wrapper');
    if (wrapper && this.forward) wrapper.removeEventListener('scroll', this.forward);
    this.io?.disconnect();
    this.mo?.disconnect();
  }
}

if (!customElements.get('lettoria-scroll-bridge')) {
  customElements.define('lettoria-scroll-bridge', LettoriaScrollBridge);
}
